<template>
  <div style="position: absolute; right: 10px; top: 50px;" class="box">
    <div class="title" style="font-size: 14pt; margin-bottom: 5px;">
      <span v-if="currentLanguage==0">Abfrage Resultat</span>
      <span v-else-if="currentLanguage==1">Résultat de la requête</span>
      <span v-else-if="currentLanguage==2">Query Result</span>
    </div>
    <div v-if="!layer.parentLayer" style="font-size: 11pt; opacity: 0.9;">
      {{ layer.name }}
    </div>
    <div v-else style="font-size: 11pt; opacity: 0.9;">
      {{ layer.parentLayer.name }}
    </div>

    <table class="table" style="font-size: 10pt;">
      <thead style="opacity: 0.7; font-size: 9.5pt;">
      <td></td>
      <td>Value</td>
<!--      <td>Uncertainty</td>-->
      </thead>
      <tbody>

      <tr v-for="(item, key) in values" :key="key" :class="{'active': item.layerId === layer.id}">
        <td style="opacity: 0.7">
          {{ item.layerName }}
        </td>
      <td v-if="item">
        {{ Math.round(item.attributes['Classify.Pixel Value'] * 100) / 100 }}
      </td>
<!--      <td v-if="uncertainty[key]">-->
<!--        {{ Math.round(uncertainty[key].attributes['Stretch.Pixel Value'] * 10) / 100 }}-->
<!--      </td>-->
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "QueryResult",
  props: {
    values: Array,
    // uncertainty: Array,
    layer: Object
  },
  computed: {
    currentLanguage() {
      return this.$store.getters.currentLanguage
    }
  },
  beforeMount() {
  }
}
</script>

<style scoped>
.active {
  background-color: aquamarine;
}
</style>
